import { useEffect, useState } from "react";
import PageScanRequestFilterCard from "./PageScanRequestFilter/PageScanRequestFilterCard";
import PageScanRequestTable from "./PageScanRequestTable/PageScanRequestTable";

import { QuarterlySpeedGoalsEndPointLogic } from "../../../../../logic/AssetManagement/Health/Quarterly Website Speed Goals/QuarterlySpeedGoalsEndPointLogic";
import { useDispatch } from "react-redux";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";
import { useSelector } from "react-redux";
import { selectUserToken } from "../../../../../features/userSlice";
import { setAddNewPageReqText } from "../../../../../features/pageSpeedPerformanceSlice";

function PageScanRequest() {
  const { selectedSharedUid } = useSelector(
    (state: any) => state.pageSpeedPerformance
  );
  const token = useSelector(selectUserToken) as any;
  const [loading, setLoading] = useState<boolean>(false);
  const [pageInternalListData, setPageInternalListData] = useState<any[]>([]);
  const [, setTogglePageSpeedData] = useState<any[]>([]);
  const [postedPageSpeedContent, setPostedPageSpeedContent] = useState<any[]>(
    []
  );
  const [errorAccToPageStatus, setErrorAccToPageStatus] = useState([]);
  const [loaderForPageSpeed, setLoaderForPageSpeed] = useState(false);
  const [selectedSearchValue, setSelectedSearchValue] = useState(null);
  const dispatch = useDispatch();

  const tableHeadings = {
    page_name: "Page Name",
    active: "Scan Status",
    tests_amount: "Scan Count",
    last_run: "Last Scan",
    created: "Requested On",
    created_by: "Requested By",
  };

  useEffect(() => {
    const fetchPageSpeedData = async (website_shared_uid: any) => {
      setLoading(true);
      try {
        await QuarterlySpeedGoalsEndPointLogic.getPageViewInternalList(
          token,
          website_shared_uid,
          setPageInternalListData,
          dispatch
        );
      } catch (error) {
        console.error("Error fetching advertising accounts:", error);
      } finally {
        setLoading(false);
        setTogglePageSpeedData([]);
        setPostedPageSpeedContent([]);
        setErrorAccToPageStatus([]);
      }
    };

    fetchPageSpeedData(selectedSharedUid);
  }, [setErrorAccToPageStatus, selectedSharedUid, token, dispatch, setLoading]);

  const postPageSpeed = async (data: any) => {
    setLoaderForPageSpeed(true);
    try {
      if (token) {
        const postedContent: any[] = []; // temporary holder
        await QuarterlySpeedGoalsEndPointLogic.postPageSpeedInternal(
          token,
          data,
          selectedSharedUid,
          (res: any) => {
            setPostedPageSpeedContent(res);
            postedContent.push(...res); // track inside outer scope
          },
          setErrorAccToPageStatus
        );
        // If successful (e.g., at least one valid entry), clear input
        if (postedContent.length > 0) {
          dispatch(setAddNewPageReqText(""));
        }
        // Refresh table data
        await QuarterlySpeedGoalsEndPointLogic.getPageViewInternalList(
          token,
          selectedSharedUid,
          setPageInternalListData,
          dispatch
        );
      } else {
        throw new Error("Permission Denied");
      }
    } catch (error) {
      console.error("Error posting or fetching page speed data:", error);
    } finally {
      setLoaderForPageSpeed(false);
    }
  };

  return (
    <>
      <PageScanRequestFilterCard
        selectedSearchValue={selectedSearchValue}
        setSelectedSearchValue={setSelectedSearchValue}
        rows={pageInternalListData ? pageInternalListData : []}
        loaderForPageSpeed={loaderForPageSpeed}
        setErrorAccToPageStatus={setErrorAccToPageStatus}
        postedPageSpeedContent={postedPageSpeedContent}
        errorAccToPageStatus={errorAccToPageStatus}
        postPageSpeed={postPageSpeed}
      />
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          <PageScanRequestTable
            setPageInternalListData={setPageInternalListData}
            selectedSearchValue={selectedSearchValue}
            tableHeadings={tableHeadings}
            rows={pageInternalListData ? pageInternalListData : []}
            loading={loading}
          />
        </>
      )}
    </>
  );
}

export default PageScanRequest;
